/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_ProjectsInputs */

const en_loading_projects = /** @type {(inputs: Loading_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your projects…`)
};

const id_loading_projects = /** @type {(inputs: Loading_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat proyekmu…`)
};

/**
* | output |
* | --- |
* | "Loading your projects…" |
*
* @param {Loading_ProjectsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_projects = /** @type {((inputs?: Loading_ProjectsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_ProjectsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_projects(inputs)
	return en_loading_projects(inputs)
});